import { render, staticRenderFns } from "./EntregaCall.vue?vue&type=template&id=5a42ca6a&"
import script from "./EntregaCall.vue?vue&type=script&lang=js&"
export * from "./EntregaCall.vue?vue&type=script&lang=js&"
import style0 from "./EntregaCall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports